export default {
  transportDatabase: 'Database Kendaraan',
  searchText: 'Cari Nama Kendaraan',
  photo: 'Foto',
  createTransport: 'Tambah Kendaraan',
  editTransport: 'Ubah Kendaran',
  transport: 'Kendaraan',
  transportType: 'Tipe Kendaraan',
  vehicleNo: 'No Kendaraan',
  dimension: 'Dimensi',
  kirExp: 'Berlaku Kir: ',
  kirExpDate: 'Masa Berlaku KIR',
  stnkExpDate: 'Masa Berlaku STNK',
  driverData: 'Data Sopir',
  expiredDate: 'Berlaku sd: ',
  createdBy: 'Dibuat Oleh',
  licenseNo: 'No Sim',
  year: 'Tahun',
  notes: 'Catatan',
  brand: 'Merk Kendaraan',
  driver: 'Sopir',
}
